var _USER_LOGIN_TYPE_MAPP, _ORG_IDENTITY_MAPPING, _SOURCE_TYPE_STATUS_T, _SOURCE_TYPE_STATUS_T2, _SOURCE_MERCHANT_DOMA, _USER_TYPE_NUM;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// 用户登录类型
export var USER_LOGIN_TYPE = /*#__PURE__*/function (USER_LOGIN_TYPE) {
  USER_LOGIN_TYPE[USER_LOGIN_TYPE["USER_LOGIN"] = 1] = "USER_LOGIN";
  USER_LOGIN_TYPE[USER_LOGIN_TYPE["ORG_LOGIN"] = 2] = "ORG_LOGIN";
  USER_LOGIN_TYPE[USER_LOGIN_TYPE["SELLER_LOGIN"] = 3] = "SELLER_LOGIN";
  USER_LOGIN_TYPE[USER_LOGIN_TYPE["PERSON_TEACHER"] = 4] = "PERSON_TEACHER";
  return USER_LOGIN_TYPE;
}({});

// 将登陆方式字符串枚举值 先内部部分使用
export var LOGIN_TYPE = /*#__PURE__*/function (LOGIN_TYPE) {
  LOGIN_TYPE["USER_LOGIN"] = "user";
  LOGIN_TYPE["ORG_LOGIN"] = "org";
  LOGIN_TYPE["SELLER_LOGIN"] = "merchant";
  LOGIN_TYPE["PERSON_TEACHER"] = "person_teacher";
  return LOGIN_TYPE;
}({});

// 登录方式字符串转数字
export var LOGIN_TYPE_STR_TO_NUM = /*#__PURE__*/function (LOGIN_TYPE_STR_TO_NUM) {
  LOGIN_TYPE_STR_TO_NUM[LOGIN_TYPE_STR_TO_NUM["user"] = 1] = "user";
  LOGIN_TYPE_STR_TO_NUM[LOGIN_TYPE_STR_TO_NUM["org"] = 2] = "org";
  LOGIN_TYPE_STR_TO_NUM[LOGIN_TYPE_STR_TO_NUM["merchant"] = 3] = "merchant";
  LOGIN_TYPE_STR_TO_NUM[LOGIN_TYPE_STR_TO_NUM["person_teacher"] = 4] = "person_teacher";
  return LOGIN_TYPE_STR_TO_NUM;
}({});
// 将登陆方式的数字枚举值转换为字符串 先内部部分使用
export var USER_LOGIN_TYPE_MAPPING = (_USER_LOGIN_TYPE_MAPP = {}, _defineProperty(_USER_LOGIN_TYPE_MAPP, USER_LOGIN_TYPE.USER_LOGIN, LOGIN_TYPE.USER_LOGIN), _defineProperty(_USER_LOGIN_TYPE_MAPP, USER_LOGIN_TYPE.ORG_LOGIN, LOGIN_TYPE.ORG_LOGIN), _defineProperty(_USER_LOGIN_TYPE_MAPP, USER_LOGIN_TYPE.SELLER_LOGIN, LOGIN_TYPE.SELLER_LOGIN), _defineProperty(_USER_LOGIN_TYPE_MAPP, USER_LOGIN_TYPE.PERSON_TEACHER, LOGIN_TYPE.PERSON_TEACHER), _USER_LOGIN_TYPE_MAPP);

// 机构身份的枚举值
export var ORG_SOURCE_TYPE_ENUM = /*#__PURE__*/function (ORG_SOURCE_TYPE_ENUM) {
  ORG_SOURCE_TYPE_ENUM["ORG"] = "org";
  ORG_SOURCE_TYPE_ENUM["SCHOOL"] = "school";
  return ORG_SOURCE_TYPE_ENUM;
}({});

// 机构身份枚举值对应的id
export var ORG_IDENTITY_MAPPING = (_ORG_IDENTITY_MAPPING = {}, _defineProperty(_ORG_IDENTITY_MAPPING, ORG_SOURCE_TYPE_ENUM.ORG, 8), _defineProperty(_ORG_IDENTITY_MAPPING, ORG_SOURCE_TYPE_ENUM.SCHOOL, 10), _ORG_IDENTITY_MAPPING);

// 资源方身份枚举
export var SOURCE_TYPE_MAPPING = {
  // 课程身份
  course: 1,
  // 题库身份
  question: 2,
  // 自有课
  self_course: 3,
  //直播培训
  live_broadcast: 4,
  // 企业
  company: 9,
  // 中心个人-马兰花讲师
  person_teacher_mlh: 11,
  // 中心个人-求职讲师
  person_teacher_job: 12
};

// 资源方用户中心身份角色
export var IDENTITY_TYPE_MAPPING = {
  // 课程身份
  course: 1,
  // 题库身份
  question: 2,
  // 自有课
  self_course: 3,
  //直播培训
  live_broadcast: 4,
  // 企业
  company: 9,
  // 中心个人-马兰花讲师
  person_teacher_mlh: 11,
  // 中心个人-求职讲师
  person_teacher_job: 12
};

// 资源方来源类型枚举
export var MERCHANT_LOGIN_TYPE = /*#__PURE__*/function (MERCHANT_LOGIN_TYPE) {
  MERCHANT_LOGIN_TYPE["COURSE"] = "course";
  MERCHANT_LOGIN_TYPE["QUESTION"] = "question";
  MERCHANT_LOGIN_TYPE["SELF_COURSE"] = "self_course";
  MERCHANT_LOGIN_TYPE["LIVE_BROADCAST"] = "live_broadcast";
  MERCHANT_LOGIN_TYPE["COMPANY"] = "company";
  MERCHANT_LOGIN_TYPE["PERSON_TEACHER"] = "person_teacher";
  return MERCHANT_LOGIN_TYPE;
}({}); // 中心个人

// 资源方身份枚举对应的文字
export var SOURCE_TYPE_STATUS_TEXT_MAP = (_SOURCE_TYPE_STATUS_T = {}, _defineProperty(_SOURCE_TYPE_STATUS_T, SOURCE_TYPE_MAPPING.course, '课程资源方'), _defineProperty(_SOURCE_TYPE_STATUS_T, SOURCE_TYPE_MAPPING.question, '题库资源方'), _defineProperty(_SOURCE_TYPE_STATUS_T, SOURCE_TYPE_MAPPING.self_course, '自有课平台方'), _defineProperty(_SOURCE_TYPE_STATUS_T, SOURCE_TYPE_MAPPING.live_broadcast, '直播培训平台方'), _defineProperty(_SOURCE_TYPE_STATUS_T, SOURCE_TYPE_MAPPING.company, '企业'), _defineProperty(_SOURCE_TYPE_STATUS_T, SOURCE_TYPE_MAPPING.person_teacher, '讲师'), _defineProperty(_SOURCE_TYPE_STATUS_T, SOURCE_TYPE_MAPPING.person_teacher_mlh, '讲师'), _defineProperty(_SOURCE_TYPE_STATUS_T, SOURCE_TYPE_MAPPING.person_teacher_job, '讲师'), _SOURCE_TYPE_STATUS_T);
export var SOURCE_TYPE_STATUS_TEXT_STR_MAP = (_SOURCE_TYPE_STATUS_T2 = {}, _defineProperty(_SOURCE_TYPE_STATUS_T2, MERCHANT_LOGIN_TYPE.COURSE, '课程资源方'), _defineProperty(_SOURCE_TYPE_STATUS_T2, MERCHANT_LOGIN_TYPE.QUESTION, '题库资源方'), _defineProperty(_SOURCE_TYPE_STATUS_T2, MERCHANT_LOGIN_TYPE.SELF_COURSE, '自有课平台方'), _defineProperty(_SOURCE_TYPE_STATUS_T2, MERCHANT_LOGIN_TYPE.LIVE_BROADCAST, '直播培训平台方'), _defineProperty(_SOURCE_TYPE_STATUS_T2, MERCHANT_LOGIN_TYPE.COMPANY, '企业'), _defineProperty(_SOURCE_TYPE_STATUS_T2, MERCHANT_LOGIN_TYPE.PERSON_TEACHER, '讲师'), _SOURCE_TYPE_STATUS_T2);

// 资源方工作台地址的字段集合，区分题库和课程资源方；除了question都是课程
export var SOURCE_MERCHANT_DOMAIN = (_SOURCE_MERCHANT_DOMA = {}, _defineProperty(_SOURCE_MERCHANT_DOMA, MERCHANT_LOGIN_TYPE.QUESTION, 'questionMerchantDomain'), _defineProperty(_SOURCE_MERCHANT_DOMA, MERCHANT_LOGIN_TYPE.COURSE, 'courseMerchantDomain'), _defineProperty(_SOURCE_MERCHANT_DOMA, MERCHANT_LOGIN_TYPE.SELF_COURSE, 'courseMerchantDomain'), _defineProperty(_SOURCE_MERCHANT_DOMA, MERCHANT_LOGIN_TYPE.LIVE_BROADCAST, 'courseMerchantDomain'), _defineProperty(_SOURCE_MERCHANT_DOMA, MERCHANT_LOGIN_TYPE.COMPANY, 'courseMerchantDomain'), _defineProperty(_SOURCE_MERCHANT_DOMA, MERCHANT_LOGIN_TYPE.PERSON_TEACHER, 'lecturerDomain'), _SOURCE_MERCHANT_DOMA);

// 组织认证状态
export var ORG_CERTIFY_STATUS_TYPE = /*#__PURE__*/function (ORG_CERTIFY_STATUS_TYPE) {
  ORG_CERTIFY_STATUS_TYPE[ORG_CERTIFY_STATUS_TYPE["UNVERIFIED"] = 0] = "UNVERIFIED";
  ORG_CERTIFY_STATUS_TYPE[ORG_CERTIFY_STATUS_TYPE["VERIFIED"] = 1] = "VERIFIED";
  ORG_CERTIFY_STATUS_TYPE[ORG_CERTIFY_STATUS_TYPE["APPROVE"] = 2] = "APPROVE";
  ORG_CERTIFY_STATUS_TYPE[ORG_CERTIFY_STATUS_TYPE["WAIT_APPROVE"] = 3] = "WAIT_APPROVE";
  return ORG_CERTIFY_STATUS_TYPE;
}({});

// 组织审核状态
export var ORG_APPROVE_STATUS_TYPE = /*#__PURE__*/function (ORG_APPROVE_STATUS_TYPE) {
  ORG_APPROVE_STATUS_TYPE[ORG_APPROVE_STATUS_TYPE["NONE"] = 0] = "NONE";
  ORG_APPROVE_STATUS_TYPE[ORG_APPROVE_STATUS_TYPE["PASS"] = 1] = "PASS";
  ORG_APPROVE_STATUS_TYPE[ORG_APPROVE_STATUS_TYPE["UN_PASS"] = 2] = "UN_PASS";
  return ORG_APPROVE_STATUS_TYPE;
}({});

// 用户类型值
export var USER_TYPE_NUM = (_USER_TYPE_NUM = {}, _defineProperty(_USER_TYPE_NUM, LOGIN_TYPE.USER_LOGIN, USER_LOGIN_TYPE.USER_LOGIN), _defineProperty(_USER_TYPE_NUM, LOGIN_TYPE.ORG_LOGIN, USER_LOGIN_TYPE.ORG_LOGIN), _defineProperty(_USER_TYPE_NUM, LOGIN_TYPE.SELLER_LOGIN, USER_LOGIN_TYPE.SELLER_LOGIN), _USER_TYPE_NUM);